<template>
    <exportTemplate :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" @set-custom-columns="setCustomColumns" @close-custom-columns="closeCustomColumns" @pagination-change="paginationChange" @form-submit="formSubmit" @sort="sortChange" ref="tabBox" @table-export="tableExport" :form-model="queryForm" @emitDblclick="emitDblclick">
        <template #form>
            <el-form-item label="当期范围" prop="billDate.selected">
                <date-picker class="query_form_item" style="width: 100%;" v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                </date-picker>
            </el-form-item>
            <el-form-item label="品牌" prop="itemBrandID.selected">
                <select-multiple :select-data="queryForm.itemBrandID"></select-multiple>
            </el-form-item>
            <el-form-item label="大类" prop="brand.selected">
                <select-multiple :select-data="queryForm.brand" :change="(val) => { brandChange(val, 1) }"></select-multiple>
            </el-form-item>
            <el-form-item label="小类" prop="brandType.selected">
                <select-multiple :select-data="queryForm.brandType" :change="(val) => { brandChange(val, 2) }"></select-multiple>
            </el-form-item>
            <el-form-item label="商品" prop="itemID.selected">
                <select-multiple :select-data="queryForm.itemID"></select-multiple>
            </el-form-item>
            <el-form-item label="业务员" prop="salesmanID.selected">
                <select-multiple :select-data="queryForm.salesmanID"></select-multiple>
            </el-form-item>
            <el-form-item label="片区" prop="domainDesc.selected">
                <select-multiple :select-data="queryForm.domainDesc"></select-multiple>
            </el-form-item>
            <el-form-item label="范围" prop="selectType.selected">
                <el-select style="width: 100%;" v-model="queryForm.selectType.selected" placeholder="请选择范围">
                    <el-option v-for="item in queryForm.selectType.list" :key="item.value" :label="item.text" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </template>
        <template>
            <el-table-column :index="1" label="商品名" prop="itemName" fixed min-width="120px"></el-table-column>
            <el-table-column :index="2" label="条码(小单位)" width="120" prop="invBarCode" v-if="customColumnList['invBarCode']"></el-table-column>
            <el-table-column :index="3" label="转换单位" prop="convertUnits" width="130" v-if="customColumnList['convertUnits']"></el-table-column>
            <el-table-column :index="4" label="类别" prop="unSaleProportion" width="120" v-if="customColumnList['unSaleProportion']"></el-table-column>
            <el-table-column :index="5" label="商品编码" prop="itemCode" width="120" v-if="customColumnList['itemCode']"></el-table-column>
            <el-table-column :index="6" label="销售金额" prop="salTotalAmt" sortable="custom" width="100"></el-table-column>
            <el-table-column :index="7" label="销售数量" prop="salUnitQty" width="120" sortable="custom"></el-table-column>
            <el-table-column :index="8" label="退货金额" prop="returnTotalAmt" sortable="custom" width="100"></el-table-column>
            <el-table-column :index="9" label="退货数量" prop="returnUnitQty" width="120" sortable="custom"></el-table-column>
            <el-table-column :index="10" label="净销售额(销-退)" prop="netSalTotalAmt" width="140" sortable="custom"></el-table-column>
            <el-table-column :index="11" label="当期销售客户数" class-name="table-item" width="110" prop="salCustomerSum">
                <template slot-scope="scope">
                    <div class="item">
                        <p>{{scope.row.salCustomerSum}}</p>
                        <p>{{scope.row.percentage}}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :index="12" label="负责客户总数" prop="customerSum" width="110"></el-table-column>
        </template>
    </exportTemplate>
</template>
<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getAddDate, getNowFormatDate, toRawType, toFixedRe, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
    name: 'ItemMarket',
    props: ['selectType', 'beginDate', 'endDate'],
    components: {
        exportTemplate,
        datePicker
    },
    data() {
        let beginDate = getAddDate(-3)
        let endDate = getNowFormatDate()
        return {
            params: {
                page: 1,
                size: 20,
                selectType: 'A'
            },
            paginationTotal: 0,
            tableList: [],
            queryForm: {
                domainDesc: { submitName: 'domainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户片区', request: { url: '/Account/domainDefine/getDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                itemID: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                itemBrandID: { submitName: 'itemBrandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: '/Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                billDate: { submitName: 'billDate', selected: [beginDate, endDate] },
                salesmanID: { submitName: "salesmanID", selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: "请选择业务员", request: { url: "/Account/userDefine/selectUserListForVue.html", type: "post", params: { page: 1, size: 5 }, text: "", value: "" } },
                brand: { submitName: 'brandID', selected: [], isMultiple: true, valueIsObj: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
                brandType: { submitName: 'itemTypeID', selected: [], isMultiple: true, valueIsObj: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: true, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
                selectType: { submitName: 'selectType', selected: 'A', list: [{ value: 'A', text: '全部' }, { value: 'B', text: '畅销商品' }, { value: 'C', text: '滞销商品' }, { value: 'D', text: '只查退货' }, { value: 'E', text: '有销售有退货' }, { value: 'F', text: '有销售无退货' }, { value: 'G', text: '有退货无销售' }] }
            },
            pickerOptions: pickerOptions,
            tableSummaryData: {},
            tableLoading: false,
            // customColumnsList: [{
            //     label: "部门",
            //     prop: "departmentName"
            // }],
            customColumnsList: [{
                    label: "条码(小单位)",
                    prop: "invBarCode"
                },
                {
                    label: "转换单位",
                    prop: "convertUnits",
                },
                {
                    label: "类别",
                    prop: "unSaleProportion",
                },
                {
                    label: "商品编码",
                    prop: "itemCode",
                },
            ],
            customColumn: [],
            transmitQuery: {}
        }
    },
    created() {
        console.log(this.selectType)
        if (this.selectType) {
            this.queryForm.selectType.selected = this.selectType
        }
        if (this.beginDate && this.endDate) {
            this.queryForm.billDate.selected = [this.beginDate, this.endDate]
        }
        this.getTableList()
        this.getCustomColumnsList()
        this.transmitQuery = JSON.parse(JSON.stringify(this.queryForm))
    },
    computed: {
        queryItem() {
            let tempItem = {}
            Object.values(this.queryForm).forEach(item => {
                if (item.submitName == 'billDate') {
                    tempItem['beginDate'] = item.selected && item.selected.length > 0 ? item.selected[0] : ''
                    tempItem['endDate'] = item.selected && item.selected.length > 0 ? item.selected[1] : ''
                } else {
                    if (toRawType(item.selected) == 'Array') {
                        tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
                    } else if (toRawType(item.selected) == 'String') {
                        tempItem[item.submitName] = item.selected || ''
                    }
                }
            })
            return tempItem
        },
        customColumnList() {
            let tempItem = {}
            this.customColumn.forEach(i => {
                tempItem[i.prop] = (i.isShow == 'Y')
            })
            console.log(tempItem)
            return tempItem
        }
    },
    methods: {
        setCustomColumns(el) {
            let tempArr = [...this.customColumn]
            el.loading = false
            el.setCustomcolumns(tempArr)
        },
        closeCustomColumns(el) {
            console.log(el)
            el.$nextTick(async () => {
                let { customColumns } = el
                const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
                    funcCode: 222,
                    customSetInfo: JSON.stringify(customColumns)
                }))
                if (res.code != 'success') return this.$message.error(res.message)
                this.$message.success(res.message)
            })
            console.log(this.customColumn)
            this.$nextTick(() => {
                this.$refs["tabBox"].$refs["table"].doLayout()
            })
        },
        paginationChange({page, size, isGetTable = true}) {
            this.params.page = page
            this.params.size = size
            if (isGetTable) {
                this.getTableList()
            }
        },
        formSubmit(el) {
            this.transmitQuery = JSON.parse(JSON.stringify(this.queryForm))
            // 复制查询参数和详情参数一致   带过去详情
            this.transmitQuery['financialBrand'] = this.queryForm.itemBrandID
            this.transmitQuery.financialBrand.submitName = 'financialBrandID'
            console.log(this.queryForm)
            console.log(this.transmitQuery)
            this.getTableList()
        },
        async getTableList() {
            // this.tableList = [{ aa: 'ere' }]
            this.tableLoading = true
            console.log(this.tableLoading)
            this.tableData = []
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/ShopMarket/selectItemMarketList.html', { ...this.params, ...this.queryItem });
            this.tableLoading = false
            if (res.code != '0') return this.$message.error(res.message)
            let { data, sum, total } = res.data
            this.paginationTotal = total
            this.tableSummaryData = sum
            this.tableList = data.map(item => {
                item.percentage = (Number(toFixedRe(Number((item.salCustomerSum / item.customerSum) || 0) * 100, 2)) || 0) + '%'
                if (item.customerSum == 0 || item.salCustomerSum == 0) item.percentage = '0%'
                return item
            })
            
        },
        sortChange({ sortField, sortBy }) {
            this.params['sortField'] = sortField
            this.params['sortBy'] = sortBy
            this.params.page = 1
            this.getTableList()
        },
        async getCustomColumnsList() {
            const { data: res } = await this.$http.post(
                "Account/dataSearchVue/selectColumnByFuncCode.html",
                this.Qs.stringify({ funcCode: 222 })
            );
            if (res.code != "success")
                return this.$confirm(res.message, "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "error",
                });
            let result = JSON.parse(res.result);
            let arr = [];
            this.customColumnsList.forEach((item) => {
                result.forEach(($item) => {
                    if (item.prop == $item.prop) {
                        arr.push({
                            id: $item.id,
                            label: item.label,
                            prop: item.prop,
                            isShow: $item.isShow,
                        });
                    }
                });
            });
            this.customColumn = [...arr]
            console.log(this.customColumn)
        },
        brandChange(val, type) { //1 大类  2 小类
            console.log(val)
            let str = val.map(item => "'" + item.value + "'").join(',')
            let big = this.queryForm.brand.selected.length > 0 ? this.queryForm.brand.selected.map(item => "'" + item.value + "'").join(',') : ''
            let small = this.queryForm.brandType.selected.length > 0 ? this.queryForm.brandType.selected.map(item => "'" + item.value + "'").join(',') : ''
            if (type == 1) {
                this.queryForm.brandType.request.params['brandID'] = str
                this.queryForm.brandType.isReSearch = true
            }
            this.queryForm.itemID.request.params['brandID'] = big
            this.queryForm.itemID.request.params['itemTypeID'] = small
            this.queryForm.itemID.isReSearch = true
        },
        tableExport(arr) {
            exportExcelCommonForVue({
                ...this.params,
                ...this.queryItem
            }, arr, '/erpnew/account/c/reada46ceb/ShopMarket/selectItemMarketListExport.html')
            console.log(arr)
        },
        emitDblclick(row) {
            console.log(this.queryItem.selectType)
            // if(this.queryItem.selectType === 'C') return
            if(!row.salUnitQty && !row.returnUnitQty) {
                this.$message({ message: '暂无数据', type: 'warning'})
                return
            }
            this.formSubmit()
            console.log(row)
            console.log(this.transmitQuery)
            for(let i in row) {
                Object.keys(this.transmitQuery).map((key) => {
                    if(row[i] && i === this.transmitQuery[key].submitName) {
                        // 需求#154：selected 为字符串的单选字段（customerLevel/customerStatus/productClassification 等）直接跳过，
                        // 避免被转成对象数组，导致销售明细表(新) 页面显示 [object Object]
                        if(!Array.isArray(this.transmitQuery[key].selected)) {
                            return
                        }
                        let arr = []
                        if(this.transmitQuery[key].selected.length) {
                            arr = this.transmitQuery[key].selected.filter(item => { return item.value === row[i] }) 
                        } else {
                            let str = i.replace('ID','Name')
                            let obj = { value: row[i], text: row[str] }
                            arr.push(obj)

                            if(i === 'itemID' || i === 'customerID') {
                                this.transmitQuery[key].list = arr
                            }
                        }
                        this.transmitQuery[key].selected = arr
                    }
                })
            }
            console.log(this.transmitQuery)
            let width = window.top.document.browser.availiframeWidth.value
            let height = window.top.document.browser.availiframeHeight.value
            let timestemp = new Date().getTime()
            this.transmitQuery.timestemp = timestemp
            top.addPanel('销售明细表(新)', `/templates/vue-account/dist/index.htm#/commodityDetails?type=1&timestemp=${timestemp}`, width, height, true, this.transmitQuery)
        }
    }
}
</script>
<style lang="less" scoped>
/deep/.table-item {
    padding: 0 !important;

    .cell {
        padding: 0 !important;
        text-align: center;
    }

    .item {

        p {
            line-height: 26px;
            flex: 1;
            text-align: center;

            &:last-child {
                border-top: 1px solid #ccc;
                color: #909399;
            }
        }
    }
}
</style>